<section class="xr-card xr-password" aria-labelledby="profile-password-title">
  <div class="xr-password-rules">
    <h2 id="profile-password-title" class="xr-card-title">{{ "change_password.title" | translate }}</h2>
    <p class="xr-password-intro">{{ "change_password.rules_intro" | translate }}</p>
    <ul>
      <li>{{ "change_password.rule_length" | translate: { minLength: passwordMinLength } }}</li>
      <li>{{ "change_password.rule_case" | translate }}</li>
      <li>{{ "change_password.rule_number" | translate }}</li>
      <li>{{ "change_password.rule_special" | translate }}</li>
    </ul>
  </div>

  <form class="xr-password-form" [formGroup]="change_password_form" (ngSubmit)="onSubmit()">
    <div class="xr-field">
      <label class="xr-field-label" for="old-password">{{ "change_password.current_password" | translate }}</label>
      <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
        <input matInput id="old-password" [type]="hideOldPassword ? 'password' : 'text'" formControlName="old_password"
               autocomplete="current-password"/>
        <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideOldPassword = !hideOldPassword"
                [attr.aria-label]="(hideOldPassword ? 'login.show_password' : 'login.hide_password') | translate"
                [attr.aria-pressed]="!hideOldPassword">
          <i-tabler [name]="hideOldPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
        </button>
        <mat-error *ngIf="change_password_form.get('old_password')?.hasError('required') && change_password_form.get('old_password')?.touched">
          {{ 'login.password_required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="xr-field">
      <label class="xr-field-label" for="new-password">{{ "change_password.new_password" | translate }}</label>
      <mat-form-field appearance="outline" color="primary" class="hide-hint">
        <input matInput id="new-password" [type]="hideNewPassword ? 'password' : 'text'" formControlName="new_password"
               autocomplete="new-password"/>
        <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideNewPassword = !hideNewPassword"
                [attr.aria-label]="(hideNewPassword ? 'login.show_password' : 'login.hide_password') | translate"
                [attr.aria-pressed]="!hideNewPassword">
          <i-tabler [name]="hideNewPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
        </button>
      </mat-form-field>
      <mat-error class="xr-field-error" *ngIf="change_password_form.get('new_password')?.hasError('required') && change_password_form.get('new_password')?.touched">
        {{ 'login.password_required' | translate }}
      </mat-error>
      <mat-error class="xr-field-error" *ngIf="change_password_form.get('new_password')?.hasError('minlength') && change_password_form.get('new_password')?.touched">
        {{ 'recovery_password.password_min_length' | translate: { minLength: passwordMinLength } }}
      </mat-error>
      <ng-container *ngIf="change_password_form.get('new_password')?.hasError('passwordStrength') && change_password_form.get('new_password')?.touched">
        <mat-error class="xr-field-error" *ngIf="!change_password_form.get('new_password')?.getError('passwordStrength')?.hasUpperCase">
          {{ 'change_password.password_requires_uppercase' | translate }}
        </mat-error>
        <mat-error class="xr-field-error" *ngIf="!change_password_form.get('new_password')?.getError('passwordStrength')?.hasLowerCase">
          {{ 'change_password.password_requires_lowercase' | translate }}
        </mat-error>
        <mat-error class="xr-field-error" *ngIf="!change_password_form.get('new_password')?.getError('passwordStrength')?.hasNumber">
          {{ 'change_password.password_requires_number' | translate }}
        </mat-error>
        <mat-error class="xr-field-error" *ngIf="!change_password_form.get('new_password')?.getError('passwordStrength')?.hasSpecialChar">
          {{ 'change_password.password_requires_special' | translate }}
        </mat-error>
      </ng-container>
    </div>

    <div class="xr-field">
      <label class="xr-field-label" for="confirm-new-password">{{ "change_password.confirm_password" | translate }}</label>
      <mat-form-field appearance="outline" color="primary" class="hide-hint">
        <input matInput id="confirm-new-password" [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirm_new_password"
               autocomplete="new-password"/>
        <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideConfirmPassword = !hideConfirmPassword"
                [attr.aria-label]="(hideConfirmPassword ? 'login.show_password' : 'login.hide_password') | translate"
                [attr.aria-pressed]="!hideConfirmPassword">
          <i-tabler [name]="hideConfirmPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
        </button>
      </mat-form-field>
      <mat-error class="xr-field-error" *ngIf="change_password_form.get('confirm_new_password')?.hasError('required') && change_password_form.get('confirm_new_password')?.touched">
        {{ 'login.password_required' | translate }}
      </mat-error>
      <mat-error class="xr-field-error" *ngIf="change_password_form.hasError('passwordMismatch') && change_password_form.touched">
        {{ 'recovery_password.passwords_dont_match' | translate }}
      </mat-error>
    </div>

    <div class="xr-password-actions">
      <button type="submit" class="xr-btn xr-btn--dark" [disabled]="!change_password_form.valid">
        {{ "change_password.change_password" | translate }}
      </button>
    </div>
  </form>
</section>
